// extracted by mini-css-extract-plugin
export var clickableWrapper = "_39-2";
export var placeholderIcon = "_39-3";
export var thumbnailCanvas = "_39-1";
export var thumbnailWrapper = "_39-0";